import auth from "../middleware/auth";
import guest from "../middleware/guest";

export default [
  {
    path: "/help/telegram",
    name: "telegram",
    component: () => import("./../views/telegram/Index.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Telegram",
          active: true
        }
      ]
    },

    pageTitle: "Помощь",
    rule: "editor"
  },
  {
    path: "/help",
    name: "help",
    component: () => import("./../views/help/Index.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          i18n: 'help',
          active: true
        }
      ]
    },

    pageTitle: "Помощь",
    rule: "editor"
  },
  {
    path: "/help/category/:category",
    name: "help-category",
    component: () => import("./../views/help/Category.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Вопросы",
          active: true
        }
      ]
    },

    pageTitle: "Категории",
    rule: "editor"
  },
  {
    path: "/help/category/question/:category/:id",
    name: "help",
    component: () => import("./../views/help/Question.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Категории",
          url: "/help",
          i18n: 'category',
          active: false
        },
        {
          title: "Вопрос ",
          active: true
        }
      ]
    },

    pageTitle: "Вопросы",
    rule: "editor"
  },

  {
    path: "/help/admin",
    name: "help-admin",
    component: () => import("./../views/help/admin/Index.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Категории",
          i18n: 'category',
          active: true
        }
      ]
    }
  },

  {
    path: "/help/admin/sub-category/:category",
    name: "help-admin-sub-category",
    component: () => import("./../views/help/admin/SubCategory.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Категории",
          i18n: 'category',
          url: "/help/admin",
          active: false
        },
        {
          title: "Субкатегории ",
          active: true
        }
      ]
    }
  },
  {
    path: "/help/admin/posts/:sub",
    name: "help-admin-posts",
    component: () => import("./../views/help/admin/Posts.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Категории",
          i18n: 'category',
          url: "/help/admin",
          active: false
        },
        {
          title: "Вопросы",
          active: true
        }
      ]
    }
  },
  {
    path: "/help/admin/add-edit-posts/:category/:sub/:id",
    name: "help-admin-edit-posts",
    component: () => import("./../views/help/admin/AddEditPosts.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Категории",
          i18n: 'category',
          url: "/help/admin",
          active: false
        },
        {
          title: "Редактирование вопросов",
          active: true
        }
      ]
    }
  },
  {
    path: "/help/admin/add-edit-posts/:category/:sub/",
    name: "help-admin-add-posts",
    component: () => import("./../views/help/admin/AddEditPosts.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          url: "/"
        },
        {
          title: "Помощь",
          url: "/help",
          i18n: 'help',
          active: false
        },
        {
          title: "Категории",
          i18n: 'category',
          url: "/help/admin",
          active: false
        },
        {
          title: "Добавление вопросов",
          active: true
        }
      ]
    }
  }
];
